import { render } from "./App.vue?vue&type=template&id=3ef968fe"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3ef968fe&lang=stylus"

import exportComponent from "D:\\tokyo-shoseki_R7\\07j\\s\\r\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__